import React, { useEffect, useState } from "react";
import { httpReauest } from "../../../utils/httpRequest";
import Loading from "../Loading";
import { CDN_BASE_URL } from "../../../config";
import { Link } from "react-router-dom";
import BlogCardImage from "../card/BlogCardImage";

const BlogsRelated = ({ related }) => {
  const [blogs, setBlogs] = useState([]);
  const [slider, setslider] = useState();
  const [loading, setloading] = useState();

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    setloading(true);
    await httpReauest(
      "GET",
      `/blog?limit=4${related ? "&related=" + related : ""}`,
      {},
      {}
    ).then(({ data }) => {
      setBlogs(data?.data);
    });

    setloading(false);
  }

  if (loading) {
    return (
      <div className="w-full flex justify-center">
        <Loading />
      </div>
    );
  }

  return (
    <>
      {blogs?.map((e, i) => (
        <span>
          <BlogCardImage data={e} />
        </span>
      ))}
    </>
  );
};

export default BlogsRelated;
